<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <div class="tag-title">{{ query.id ? '编辑文章' : '添加文章' }}</div>
      <Row>
        <Col span="9">
          <FormItem label="标题" prop="title">
            <Input v-model="form.title" placeholder="请输入标题"></Input>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem label="作者" prop="author">
            <Input v-model="form.author" placeholder="请输入作者"></Input>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem label="文章分类" prop="cid">
            <Select placeholder="请选择文章分类" v-model="form.cid">
              <Option v-for="item in apiData.categoryList" :value="item.id" :label="item.title" :key="item.id"></Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem label="原文链接" prop="url">
            <Input v-model="form.url" placeholder="请输入原文链接"></Input>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem label="状态" prop="status">
            <RadioGroup v-model="form.status">
              <Radio label="1">有效</Radio>
              <Radio label="0">无效</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem label="文章简介" prop="summary">
            <Input type="textarea" v-model="form.summary" placeholder="请输入文章简介"></Input>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem label="虚拟浏览量">
            <InputNumber v-model="form.views" placeholder="请输入虚拟浏览量"></InputNumber>
          </FormItem>
        </Col>
        <Col span="9">
          <FormItem label="排序" prop="sort">
            <InputNumber style="width: 100%" v-model="form.sort" placeholder="请输入排序"></InputNumber>
          </FormItem>
        </Col>

        <Col span="24">
          <FormItem label="图文封面" prop="image_input">
            <upload-file-one
              @on-change="imageInputChange"
              :path="form.image_input"
              :url="form.image_input_url"
              tips="建议尺寸：500 * 312 px"
            ></upload-file-one>
          </FormItem>
        </Col>
      </Row>
      <div class="tag-title">文章内容</div>
      <Row>
        <Col span="18">
          <FormItem label="文章内容" prop="content">
            <editor v-model="form.content" width="375px"></editor>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
    <Button style="width: 90px" @click="$router.go(-1)">取消</Button>
  </div>
</template>

<script>
  import uploadFileOne from '@/components/upload-custom/upload-file-one.vue'
  import editor from '@/components/editor/editor.vue'
  import * as apiArticle from '@/api/article'
  export default {
    components: {
      uploadFileOne,
      editor,
    },
    name: 'add-form',
    data() {
      return {
        query: {},
        search: {},
        diyDom: {},
        // 表单数据
        form: {
          title: '', // 标题
          author: '', // 作者
          cid: '',
          image_input: '', // 封面
          image_input_url: '', // 封面展示
          summary: '', // 简介
          sort: 0, // 排序
          url: '', // 原文链接
          status: '1', // 状态
          views: 0, // 虚拟浏览量
          content: '', // 文章内容
        },
        diyData: {
          rules: {
            title: [
              {
                required: true,
                message: '标题不能为空',
                trigger: 'blur',
              },
            ],
            cid: [
              {
                required: true,
                message: '文章分类不能为空',
                trigger: 'change',
              },
            ],
            content: [
              {
                required: true,
                message: '文章内容不能为空',
                trigger: 'change',
              },
            ],
            image_input: [
              {
                required: true,
                message: '封面不能为空',
                trigger: 'change',
              },
            ],
            status: [
              {
                required: true,
                message: '状态不能为空',
                trigger: 'change',
              },
            ],
          },
        },
        apiData: {
          categoryList: [],
        },
      }
    },
    computed: {},
    methods: {
      // 获取文章分类
      getCategory() {
        apiArticle.apiArticleCategoryListNoPage().then(res => {
          this.apiData.categoryList = res.data.map(item => {
            return {
              ...item,
              id: item.id + '',
            }
          })
        })
      },
      // 图片上传成功
      imageInputChange(data) {
        this.form.image_input = data.path
        this.form.image_input_url = data.url
      },
      // 获取详情
      getDetail() {
        this.$store.commit('setSpinShow', true)
        apiArticle
          .apiArticleDetail(this.query.id)
          .then(res => {
            const { data } = res
            this.form.title = data.title
            this.form.author = data.author
            this.form.cid = data.cid
            this.form.image_input = data.image_input
            this.form.summary = data.summary
            this.form.sort = Number(data.sort)
            this.form.url = data.url
            this.form.status = data.status + ''
            this.form.views = Number(data.views)
            this.form.content = data.content
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      submit() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            this.$store.commit('setSpinShow', true)
            if (this.query.id) {
              apiArticle
                .apiArticleEdit(this.query.id, { ...this.form })
                .then(res => {
                  this.$Message.success('编辑文章成功')
                  this.$router.go(-1)
                })
                .finally(() => this.$store.commit('setSpinShow', false))
            } else {
              apiArticle
                .apiArticleAdd({ ...this.form })
                .then(res => {
                  this.$Message.success('新增文章成功')
                  this.$router.go(-1)
                })
                .finally(() => this.$store.commit('setSpinShow', false))
            }
          }
        })
      },
    },
    mounted() {
      this.query = this.$route.query
      this.getCategory()
      this.query.id && this.getDetail()
    },
  }
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      border-left: 5px solid #2d8cf0;
      padding: 0 0 0 10px;
      margin: 0 20px 20px;
      font-weight: bold;
    }
  }
</style>
